import "./LoanReceiptDetail.scss"

import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoSectionContainer,
    showErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {useParams} from "react-router-dom";
import {useAuthState} from "../../../../context/AuthContext";
import {LoanService} from "../../../../serverService/loan/LoanService";
import {LoadingHelper} from "../../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../../context/LoadingContext";
import {useEffect, useState} from "react";
import {readToken} from "../../../../service/authService/AuthService";
import axios from "axios";
import {Skeleton} from "@mui/material";
import {css} from "@emotion/css";
import {detectServerErrorMessage} from "../../../../util/detectServerErrorMessage";

export default function LoanReceiptDetail(
    {
        receiptUrl,
        handleUpdateReceipt
    }) {

    const {id: loanId} = useParams()

    const {fundID} = useAuthState()

    const service = new LoanService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [imageFile, setImageFile] = useState(null)
    const [image, setImage] = useState("");
    const [thumbnailLoading, setThumbnailLoading] = useState(false);

    const [loadingReceipt, setLoadingReceipt] = useState(false);


    useEffect(() => {
        const fetchImage = async () => {
            try {
                const token = readToken();

                const response = await axios.get(receiptUrl, {
                    headers: {
                        Authorization: `bearer ${token}`,
                        'realm-name': 'raiko-manager-fund-web'
                    },
                    responseType: 'blob'
                });

                const imageObjectURL = URL.createObjectURL(response.data);
                setImage(imageObjectURL);
                setLoadingReceipt(false)
            } catch (error) {
                showErrorMessage('خطا در دریافت رسید تراکنش');
                setLoadingReceipt(false)
            }
        };

        if (receiptUrl && receiptUrl.length > 0) {
            setLoadingReceipt(true)
            fetchImage();
        }
    }, [receiptUrl]);


    function uploadReceiptImageFile({target: {files}}) {
        if (typeof files[0] !== 'undefined') {
            setImageFile(files[0])
            setImage(URL.createObjectURL(files[0]))
        }
    }

    function handleUploadReceipt() {
        if (imageFile) {
            loading.show()
            service.uploadReceiptFile(
                fundID,
                loanId,
                imageFile
            ).then(response => {
                showSuccessMessage("بروزرسانی رسید با موفقیت انجام شد.")
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        } else
            showWarningMessage("لطفا ابتدا تصویر رسید مورد نظر را انتخاب نمایید.")
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoSectionContainer
                    title={"رسید پرداخت وام"}
                    actionButtonTitle={"بروزرسانی"}
                    hasActionButton
                    actionButtonOnclick={handleUploadReceipt}
                    actionButtonLoadingState={loadingReceipt}
                >
                    <div
                        className={"baseLoanReceiptDetailContainer"}
                        onClick={_ => document.getElementById("receiptImageFile").click()}
                    >
                        <input
                            type="file"
                            id="receiptImageFile"
                            hidden={true}
                            multiple={true}
                            accept="image/png,image/gif,image/jpeg"
                            onChange={uploadReceiptImageFile}
                        />
                        {
                            loadingReceipt ?
                                <Skeleton variant="rectangular" className={css`padding: 100px 100px`}/> :
                                <div className={"imageReceiptContainer"}>
                                    {
                                        image ?
                                            <img
                                                src={image}
                                                id={"image"}
                                                alt="receiptImageFile"/> :
                                            imageFile ?
                                                <img
                                                    src={imageFile}
                                                    id={"image"}
                                                    alt="receiptImageFile"/>
                                                :
                                                <div className="ic-picture"/>
                                    }
                                </div>
                        }
                        <span>برای انتخاب رسید تراکنش کلیک نمایید.</span>
                        <div
                            onDragOver={event => {
                                event.stopPropagation();
                                event.preventDefault();
                                event.dataTransfer.dropEffect = 'copy';
                            }}
                            onDrop={event => {
                                event.stopPropagation();
                                event.preventDefault();
                                uploadReceiptImageFile({target: {files: event.dataTransfer.files}})
                            }}
                            id="uploadImageContent">

                        </div>

                    </div>
                </RaikoSectionContainer>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )

}
